export const tokens = {
  navy: '#0B1D33',
  darkNavy: '#071422',
  gold: '#C49A45',
  softGold: '#D8B66A',
  ivory: '#F7F4ED',
  white: '#FFFFFF',
  charcoal: '#20252B',
  muted: '#6D747C',
  line: '#E4DFD4',
  navyLine: '#1A314C',
  error: '#9B2C2C',
};
